import * as React from 'react';
import SegmentedControl from '../../../../Form/SegmentedControl';
import { T } from '../../../../../Translations';
import { ShareBy } from '../Stores/ShareStore/Types';

interface Props {
  shareBy: ShareBy;
  onChange: (value: ShareBy) => void;
}

const ShareMethodSelector: React.FC<Props> = ({ shareBy, onChange }) => {
  return (
    <div className="mb-6">
      <SegmentedControl
        options={[
          {
            value: 'email',
            label: <T kind="Share by Email" />,
            dataAttributes: { 'data-intercom-target': 'share-by-email-button' },
          },
          {
            value: 'url',
            label: <T kind="Share by URL" />,
            dataAttributes: { 'data-intercom-target': 'share-by-url-button' },
          },
        ]}
        value={shareBy}
        onChange={(value) => onChange(value as ShareBy)}
      />
    </div>
  );
};

export default ShareMethodSelector;
